import { Link } from 'react-router-dom';
import { FACTORIES, TOOLS } from '../data/processControlSystem';
import './ProcessControlSystemPage.css';

/**
 * Process Control System home.
 *
 * Renders the four factories as a 2×2 glassmorphism card grid. Each card shows
 * a large square factory label on the left; the three tool options on the right
 * are hidden by default and slide in on hover (and on keyboard `focus-within`,
 * so the options stay reachable without a pointer). Every option links to the
 * parameterized tool sub-page.
 */
export function ProcessControlSystemPage() {
  return (
    <div className="page pcs">
      <div className="pcs__bg" aria-hidden />

      <header className="pcs__header">
        <h1 className="pcs__title">
          <span className="pcs__brand">DAP-AI</span>: Process Control System
        </h1>
        <p className="pcs__subtitle">
          Select a factory, then choose a process-control tool to open.
        </p>
      </header>

      <div className="pcs__grid">
        {FACTORIES.map((factory) => (
          <section className="pcs-card" key={factory.slug}>
            <div className="pcs-card__label">
              <span className="pcs-card__label-text">{factory.label}</span>
            </div>

            <div className="pcs-card__tools">
              {TOOLS.map((tool) => (
                <Link
                  key={tool.slug}
                  to={`/portal/supplier-process-control/system/${factory.slug}/${tool.slug}`}
                  className="pcs-card__tool"
                >
                  <span className="pcs-card__tool-label">{tool.label}</span>
                  <span className="pcs-card__tool-arrow" aria-hidden>
                    →
                  </span>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
